<div class="aircraft-assign-content">
    <ngx-ui-loader
        [loaderId]="chartName"
        bgsColor="rgb(100, 181, 246)"
        bgsPosition="center-center"
        bgsType="ball-spin"
        overlayColor="rgba(0, 0, 0, 0.1)"
    ></ngx-ui-loader>
    <div>
        <mat-form-field>
            <input
                [(ngModel)]="data.tailNumber"
                aria-label="Tail Number"
                cdkFocusInitial
                matInput
                placeholder="Tail Number"
            />
        </mat-form-field>
    </div>
    <div>
        <app-autocomplete-search
            label="Aircraft Make/Model"
            [optionValue]="['make', 'model']"
            [options]="aircraftTypes"
            [displayFn]="displayAircraft"
            [(ngModel)]="selectedAircraft"
            (selectionChanged)="onAircraftSelected($event)"
        ></app-autocomplete-search>
    </div>
    <div>
        <app-autocomplete-search
            label="Customer"
            [optionValue]="'company'"
            [options]="data?.customers || []"
            [displayFn]="displayCustomer"
            [(ngModel)]="selectedCustomer"
            (selectionChanged)="onCustomerSelected($event)"
            (filterChanged)="onCustomerFilterChanged($event)"
        ></app-autocomplete-search>
        <div *ngIf="isCustomerEditable" class="add-custom-customer">
            <a (click)="addCustomCustomer()">&lt;Add Custom&gt;</a>
        </div>
    </div>
</div>
<div class="dialog-actions">
    <button
        [disabled]="isSubmitDisabled()"
        (click)="onSubmit()"
        class="mr-1"
        color="accent"
        mat-flat-button
    >
        {{ loading ? "" : "Add Aircraft" }}
        <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
    </button>
    <button (click)="onClose()" mat-stroked-button>Cancel</button>
</div>
